import { getDeliveryShopId as getUniqueShopId } from '@epicuro-next/utilities';
import {
  BasketAccountAddress,
  BasketItem,
} from 'graphql-api/baskets-api-interfaces';

export function getBasketItemsToAdd(
  basketItems: BasketItem[],
  shopFrom: BasketAccountAddress,
  shopsTo: BasketAccountAddress[],
): BasketItem[] {
  const itemsToCopy = basketItems.filter((item) => {
    return (
      getUniqueShopId({
        accountId: item.accountId,
        addressId: item.addressId as string,
      }) === getUniqueShopId(shopFrom)
    );
  });

  return shopsTo.flatMap((shop) =>
    itemsToCopy.map((item) => {
      return {
        ...item,
        accountId: shop.accountId,
        addressId: shop.addressId,
      };
    }),
  );
}
